import React from "react";
import useFacebookMessageConfirmOrder from "../../hooks/useFacebookMessageConfirmOrder";
import {LivestreamMessageConfirm} from "../content/livestreamMessage";
import {StyledFacebookMessageConfirmOrderEdit} from "../content/_styled";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import {Text} from "../../../../../../common/text";

export const LivestreamContent = props => {
  const {t} = useTranslation()
  const {data, methods} = useFacebookMessageConfirmOrder()
  const {list, content_message, samples, validate, reset, status} =
    data.livestreamDetail || {}
  
  const displayMessage = content_message && Array.isArray(content_message) && content_message.length > 0 
    ? content_message 
    : (samples && Array.isArray(samples) && samples.length > 0 ? samples : [])
  
  return (
    <StyledFacebookMessageConfirmOrderEdit
      {...props}
      className="livestream-message-confirm"
    >
      <style>{`
        .livestream-message-confirm .slate-js-edit {
          height: 148px !important;
          max-height: 148px !important;
        }
        .livestream-message-confirm .slate-js-layout {
          height: 184px !important;
        }
      `}</style>
      {+status === 1 && (
        <div>
          <LivestreamMessageConfirm
            header={'contentMessage'}
            description={'livestreamQuickOrderConfirmDescription'}
            sample={samples || []}
            onResetDefault={methods?.onResetLivestream}
            message={displayMessage}
            onChangeMessage={methods.onChangeLivestreamMessage}
            onBlurMessage={methods.onBlurLivestreamMessage}
            validateMessage={validate}
            placeHolder={'typeToCreateMessage'}
            resetDefault={reset}
            list={list || []}
          />
          <StyledFacebookPolicyNote>
            <div style={{display: 'flex', alignItems: 'flex-start', gap: 4}}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{flexShrink: 0, marginTop: 2}}
              >
                <g clipPath="url(#clip0_45002_57673)">
                  <path
                    d="M2.50966 15.1616L8.92069 4.08803C9.27501 3.47602 9.45217 3.17001 9.6833 3.06724C9.88492 2.97759 10.1151 2.97759 10.3167 3.06724C10.5478 3.17001 10.725 3.47602 11.0793 4.08802L17.4903 15.1616C17.8459 15.7758 18.0237 16.0829 17.9975 16.335C17.9745 16.5548 17.8594 16.7546 17.6806 16.8846C17.4756 17.0336 17.1207 17.0336 16.411 17.0336H3.58898C2.87925 17.0336 2.52439 17.0336 2.31942 16.8846C2.14065 16.7546 2.02547 16.5548 2.00254 16.335C1.97627 16.0829 2.15406 15.7758 2.50966 15.1616Z"
                    fill="#FF9F41"
                  />
                  <path
                    d="M10 8V12M10 14.6667H10.0083"
                    stroke="white"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_45002_57673">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <div style={{display: 'grid'}}>
                <Text
                  fontSize={16}
                  fontWeight={600}
                  color="#00081D"
                >
                  {t('facebookPolicyNoteTitle')}:
                </Text>

                <Text fontSize={14} color="#00081D">
                  <span style={{ margin: '0 8px 0 6px' }}>&bull;</span>{t('facebookPolicyNote1')}
                </Text>

                <Text fontSize={14} color="#00081D">
                  <span style={{ margin: '0 8px 0 6px' }}>&bull;</span>{t('facebookPolicyNote2')}
                </Text>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                  }}
                >
                  <Text
                    fontSize={14}
                    color="#00081D"
                    style={{marginRight: '4px', flexShrink: 0}}
                  >
                    =&gt;
                  </Text>
                  <Text
                    fontSize={14}
                    color="#00081D"
                    style={{textAlign: 'justify'}}
                  >
                    {t('facebookPolicyNote3')}
                  </Text>
                </div>
              </div>
            </div>
          </StyledFacebookPolicyNote>
        </div>
      )}
    </StyledFacebookMessageConfirmOrderEdit>
  )
}

const StyledFacebookPolicyNote = styled.div`
  margin-top: 12px;
  padding: 8px 34px 8px 12px;
  background-color: rgba(255, 159, 65, 0.1);
  border: 1px solid #ff9f41;
  border-radius: 8px;
`

